export enum MessageTypeEnum {
  SMS = 'SMS',
  MMS = 'MMS'
}
